import { Usuario } from '../../../usuario';
import { FunilVendaSearchFunilVenda } from '../../funil-venda/funil-venda-search';
import { FunilVendaFaseSearch, isFunilVendaFaseTipoOportunidade, isFunilVendaFaseTipoQualificacao } from '../../funil-venda/fase';
import { Lead } from '../../lead';
import { Cliente } from '../../../pessoa/cliente/cliente';
import { NegocioQualificacaoCreate } from '../qualificacao/negocio-qualificacao-create';
import { NegocioOportunidadeCreate } from '../oportunidade/negocio-oportunidade-create';

export class NegocioFormInsert {
    // Funil de Venda
    idFunilVenda: number;
    funilVenda: FunilVendaSearchFunilVenda;
    canEditFunilVenda: boolean;
    tiposFunilVendaFasesFilter: number[];

    // Funil Venda Fase
    funilVendaFase: FunilVendaFaseSearch;
    idFunilVendaFase: number;
    tipoFunilVendaFase: number;
    canEditFunilVendaFase: boolean;
    // isShowFunilVendaFase: boolean;

    isShowFunilVenda: boolean;

    // Lead
    novoLead: boolean;
    idLead: number;
    lead: Lead;
    isShowLead: boolean;

    // Cliente
    idCliente: number;
    cliente: Cliente;
    isShowCliente: boolean;

    // Negócio
    idUsuarioResponsavel: number;
    usuarioResponsavel: Usuario;
    prioridade: number;
    dataPrevisaoFechamento: Date;
    valor: number;
    idCampanha: number;

    constructor(idFunilVenda: number, tipoFunilVendaFase: number = null, idLead: number = null, idCliente: number = null) {
        // Funil de Venda
        this.idFunilVenda = idFunilVenda;
        this.canEditFunilVenda = !idFunilVenda;

        // Funil Venda Fase
        this.tipoFunilVendaFase = tipoFunilVendaFase;
        if (tipoFunilVendaFase) { // Se informado o tipo da fase, então não deixamos o usuário editar e filtramos os funis somente por este tipo de fase
            this.canEditFunilVendaFase = false;
            this.tiposFunilVendaFasesFilter = [tipoFunilVendaFase];
        } else { // Se não, deixamos o usuário selecionar e não aplicamos o filtro do tipo da fase
            this.canEditFunilVendaFase = true;
            this.tiposFunilVendaFasesFilter = null;
        }

        this.isShowFunilVenda = !idFunilVenda || !tipoFunilVendaFase;

        // Lead
        this.novoLead = false;
        this.idLead = idLead;
        this.isShowLead = !idLead;

        // Cliente
        this.idCliente = idCliente;
        this.isShowCliente = !idCliente;
    }

    isFaseQualificacao(): boolean {
        return isFunilVendaFaseTipoQualificacao(this.tipoFunilVendaFase);
    }

    isFaseOportunidade(): boolean {
        return isFunilVendaFaseTipoOportunidade(this.tipoFunilVendaFase);
    }

    createQualificacao(): NegocioQualificacaoCreate {
        const negocio = new NegocioQualificacaoCreate();
        negocio.idFunilVenda = this.idFunilVenda;
        negocio.novoLead = this.novoLead;
        negocio.idLead = this.idLead;
        negocio.lead = this.lead;
        negocio.idUsuarioResponsavel = this.idUsuarioResponsavel;
        negocio.prioridade = this.prioridade;
        negocio.dataPrevisaoFechamento = this.dataPrevisaoFechamento;
        negocio.valor = this.valor;
        negocio.idCampanha = this.idCampanha;

        return negocio;
    }

    createOportunidade(): NegocioOportunidadeCreate {
        const negocio = new NegocioOportunidadeCreate();
        negocio.idFunilVenda = this.idFunilVenda;
        negocio.idCliente = this.idCliente;
        negocio.idUsuarioResponsavel = this.idUsuarioResponsavel;
        negocio.prioridade = this.prioridade;
        negocio.dataPrevisaoFechamento = this.dataPrevisaoFechamento;
        negocio.valor = this.valor;
        negocio.idCampanha = this.idCampanha;

        return negocio;;
    }
}
